import colors from '../../colors';
import sizes from '../../sizes';

const lightNative = {
    current: {
        focus: {
            container: {
                // Remove boxShadow, keep simple border
                borderWidth: 2,
                borderColor: colors.green500,
                borderRadius: sizes.radius.xs,
                borderBottomWidth: 2,
                borderBottomColor: colors.primary500,
                paddingBottom: 12,
                paddingTop: 0,
                paddingLeft: 4,
                paddingRight: 4,
                height: 32
            }
        }
    },
    inactive: {
        focus: {
            container: {
                // Remove boxShadow for native
                borderWidth: 2,
                borderColor: colors.green500,
                borderRadius: sizes.radius.xs,
                paddingBottom: 12,
                paddingTop: 0,
                paddingLeft: 4,
                paddingRight: 4,
                height: 32
            }
        }
    },
    panel: {
        padding: `0 ${sizes.fixedSpacing['md']}px`
    }
};

export default lightNative;
